const state = () => ({
  stripeConnectSkipped: localStorage.getItem('stripeConnectSkipped') || false,
});

const getters = {
  stripeConnectSkipped: state => state.stripeConnectSkipped,
};

const actions = {
  async skipStripeConnect({ commit }, stripeConnectSkipped) {
    commit('SET_STRIPE_CONNECT_SKIPPED', stripeConnectSkipped);
    localStorage.setItem('stripeConnectSkipped', stripeConnectSkipped);
  },
  removeStripeConnectFlag() {
    localStorage.removeItem('stripeConnectSkipped');
  },
};

const mutations = {
  SET_STRIPE_CONNECT_SKIPPED(state, value) {
    state.stripeConnectSkipped = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
